import HTTP from "./HTTP.js";
import HttpV2 from "./V2/HttpV2.js";
import SymfonyErrorFormatter from "./SymfonyErrorFormatter";

class LookupServices {
  static async getClients() {
    return HTTP.get("lookups/clients");
  }

  static async getAgencies() {
    return HTTP.get("lookups/agencies");
  }

  static async getPackages() {
    return HTTP.get("lookups/packages");
  }

  static async getUsers() {
    return HTTP.get("lookups/users");
  }

  static async getAgents() {
    return HttpV2.get("agents");
  }
}

export default LookupServices;
